import { type ReactNode } from 'react'
import { QrCodeBox } from './QrCodeBox'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: ReactNode
  description?: ReactNode
  value: string
  displayCode?: string
  /** Rendered under the code — e.g. a copy-link button. */
  footer?: ReactNode
}

export function InviteQrDialog({ open, onOpenChange, title, description, value, displayCode, footer }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="flex flex-col items-center gap-3 py-2">
          <QrCodeBox value={value} />
          {displayCode && (
            <span className="font-mono text-sm tracking-widest bg-muted px-2 py-0.5 rounded">
              {displayCode}
            </span>
          )}
          {footer}
        </div>
      </DialogContent>
    </Dialog>
  )
}
